/* Chiffon Banaras — Luxury Product Page JS | v1.0.0 */
(function(){'use strict';

/* ── Gallery ───────────────────────────────────────────── */
function initGallery(){
  var slides=document.querySelector('.cb-gallery__slides');
  var dots=document.querySelectorAll('.cb-gallery__dot');
  var thumbs=document.querySelectorAll('.cb-gallery__thumb');
  var stack=document.querySelectorAll('.cb-gallery__stack-item');
  var mainImg=document.querySelector('.cb-gallery__main-img');

  if(!slides&&!stack.length)return;

  /* Mobile: sync dots on scroll */
  if(slides&&dots.length){
    var debounceTimer;
    slides.addEventListener('scroll',function(){
      clearTimeout(debounceTimer);
      debounceTimer=setTimeout(function(){
        var idx=Math.round(slides.scrollLeft/slides.offsetWidth);
        dots.forEach(function(d,i){d.classList.toggle('is-active',i===idx);});
      },60);
    },{passive:true});
  }

  /* Desktop: thumbnail click → scroll stack + swap main image */
  if(thumbs.length&&stack.length){
    thumbs.forEach(function(th,i){
      th.addEventListener('click',function(){
        thumbs.forEach(function(t){t.classList.remove('is-active');});
        th.classList.add('is-active');
        if(stack[i]){
          stack[i].scrollIntoView({behavior:'smooth',block:'nearest'});
        }
      });
    });

    /* IntersectionObserver: highlight thumb when stack-item is in view */
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var idx=Array.from(stack).indexOf(e.target);
          thumbs.forEach(function(t,i){t.classList.toggle('is-active',i===idx);});
        }
      });
    },{threshold:0.5});
    stack.forEach(function(s){io.observe(s);});
  }
}

/* ── Accordion ──────────────────────────────────────────── */
function initAccordions(){
  var items=document.querySelectorAll('.cb-accordion__item');
  items.forEach(function(item){
    var trigger=item.querySelector('.cb-accordion__trigger');
    if(!trigger)return;
    trigger.addEventListener('click',function(){
      var isOpen=item.classList.contains('is-open');
      /* close all others */
      items.forEach(function(i){i.classList.remove('is-open');i.querySelector('.cb-accordion__trigger').setAttribute('aria-expanded','false');});
      if(!isOpen){
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded','true');
      }
    });
  });
}

/* ── Sticky ATC ─────────────────────────────────────────── */
function initStickyAtc(){
  var bar=document.querySelector('.cb-sticky-atc');
  var atcArea=document.querySelector('.cb-atc-native');
  if(!bar||!atcArea)return;

  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      bar.classList.toggle('is-visible',!e.isIntersecting);
    });
  },{threshold:0.15});
  io.observe(atcArea);

  /* Sticky ATC button → clicks native ATC */
  var stickyBtn=bar.querySelector('.cb-sticky-atc__btn');
  var nativeBtn=document.querySelector('.cb-atc-native .shopify-payment-button__button, .cb-atc-native [name="add"], .cb-atc-native button[data-testid]');
  if(stickyBtn&&nativeBtn){
    stickyBtn.addEventListener('click',function(){nativeBtn.click();});
  }
}

/* ── Price display ─────────────────────────────────────── */
function updateStickyPrice(){
  var priceEl=document.querySelector('.cb-price[data-price]');
  var stickyPrice=document.querySelector('.cb-sticky-atc__price');
  if(priceEl&&stickyPrice){
    stickyPrice.textContent=priceEl.textContent;
  }
}

/* ── Image zoom (desktop) ───────────────────────────────── */
function initZoom(){
  var stackItems=document.querySelectorAll('.cb-gallery__stack-item');
  if(!stackItems.length)return;
  stackItems.forEach(function(item){
    item.addEventListener('click',function(){
      var img=item.querySelector('img');
      if(!img)return;
      var dialog=document.createElement('dialog');
      dialog.style.cssText='margin:auto;padding:0;border:none;background:var(--cb-ink);max-width:90vw;max-height:90vh;overflow:hidden';
      var zImg=document.createElement('img');
      zImg.src=img.src.replace(/width=\d+/,'width=1800');
      zImg.style.cssText='display:block;max-width:90vw;max-height:90vh;object-fit:contain';
      zImg.alt=img.alt;
      dialog.appendChild(zImg);
      document.body.appendChild(dialog);
      dialog.showModal();
      dialog.addEventListener('click',function(){dialog.close();dialog.remove();});
    });
  });
}

/* ── Boot ───────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded',function(){
  initGallery();
  initAccordions();
  initStickyAtc();
  updateStickyPrice();
  initZoom();
});

})();